export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderSuggestions.png";